import {
	CurrentUserRoleLike,
	isOrganizationAdmin,
	isOrganizationAdminRole,
} from './hierarchySelection';

export interface SecurityRoleLike extends CurrentUserRoleLike {
	'@id'?: string;
}

export const canAssignOrganizationAdminRole = (
	currentUserRole: CurrentUserRoleLike | null
): boolean => isOrganizationAdmin(currentUserRole);

/**
 * Returns security roles the logged-in user is allowed to assign.
 * Only Organization Admins and admin@byod.ai may assign the Organization Admin role.
 */
export const getAssignableSecurityRoles = <T extends SecurityRoleLike>(
	securityRoles: T[],
	currentUserRole: CurrentUserRoleLike | null
): T[] => {
	if (canAssignOrganizationAdminRole(currentUserRole)) {
		return securityRoles;
	}

	return securityRoles.filter((role) => !isOrganizationAdminRole(role));
};

export const isSecurityRoleAssignmentPermitted = (
	securityRoleResource: string | undefined,
	securityRoles: SecurityRoleLike[],
	currentUserRole: CurrentUserRoleLike | null
): boolean => {
	if (!securityRoleResource) return false;

	const selectedRole = securityRoles.find((role) => role['@id'] === securityRoleResource);
	if (!selectedRole) return false;

	return getAssignableSecurityRoles(securityRoles, currentUserRole).some(
		(role) => role['@id'] === securityRoleResource
	);
};

export { isOrganizationAdminRole };
